import Vue from 'vue'
import App from './App.vue'
import router from './router'

import ElementUI from 'element-ui';
Vue.use(ElementUI);
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/editer.css';
import '@/assets/css/animate.css';
import axios from 'axios';
Vue.prototype.$http = axios
Vue.config.productionTip = false
import api from './api'
Vue.prototype.$api = api
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return originalPush.call(this, location).catch(err => { })
}
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
